module.exports = __webpack_public_path__ + "img/calculator.7b6291be.svg";